import React from "react";

export const BenefitBox: React.FC<{
    name: string;
}> = ({ name }) => {
    return (
        <div className='border-green rounded-md mr-4 mb-4 bg-white items-center'>
            <div className='flex items-center px-2 py-1 text-sm font-bold'>
                {name}
            </div>
        </div>
    )
}